export default{
    _TOKEN_KEY: 'token',
    _LANG_KEY: 'lang',
    _DEFAULT_LANG: 'en',
    _API_URL: 'https://dragonhash.shelldao.cash/api/',
    _DEFAULT_GAME_REWARDS_: [[195,0,0],[195,195,0],[195,1425,195]],
    _GAME_PRESET_AMOUNT: [50,100,200,500,1000,2000],
    // _BET_COLORS: ['Gray','LightSalmon','CornflowerBlue','DarkGreen','Orchid','gold'],
    // _GAMES:
}